module.exports = __webpack_public_path__ + "static/hero-9f30d506525380133094e109eec870bf.svg";